import { render, staticRenderFns } from "./EditArtigo.vue?vue&type=template&id=e5c315f8"
import script from "./EditArtigo.vue?vue&type=script&lang=js"
export * from "./EditArtigo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports